//NEW: UI_REVAMP
import { Text } from '@chakra-ui/react';
import { ConvertedFullServerTime } from '../../utils/Time';

const ServerTime = ({ ...props }) => {
	const serverTime = ConvertedFullServerTime();
	return (
		<Text
			fontSize={{ base: '12px', lg: '16px' }}
			fontWeight={{ base: 500, lg: 600 }}
			color={{ base: 'white', lg: 'rgba(76, 49, 253, 1)' }}
			{...props}
		>
			{serverTime === 'Invalid Date' ? '--:-- --' : serverTime}
		</Text>
	);
};

export default ServerTime;
